export default __webpack_public_path__ + "static/apertura-5b046a451a89fdd4f9ca72b34e5d81a4.png";